var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({ width: _vm.progress + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }